import Checkbox from "antd/es/checkbox/Checkbox";
import {FC, useEffect, useState} from "react";
import {TableColumn} from "react-data-table-component";
import {ButtonBox, GridTable, LoadingBox} from "..";
import {ActionTypeEnum, RequestActionModel, RowStateEnum} from "../../models";
import {UserBranchPermissionModel} from "../../models/user/userPermissionResponseModel";
import {getUserBranchPermission, saveUserBranchPermissions,} from "../../serviceBroker/userApiServiceBroker";
import {getLabelName, getUserId, isArabicCurrentLanguage} from "../../utils";

export const UserBranchPermissions: FC<{
  onActionEvent: (o: RequestActionModel) => void;
}> = ({ onActionEvent = () => {} }) => {
  //#region variable
  const isArabic: boolean = isArabicCurrentLanguage();
  const userId = getUserId();

  //#endregion
  //#region state
  const [loading, setLoading] = useState(false);
  const [userPermissionObject, setUserPermissionObject] = useState<
    UserBranchPermissionModel[]
  >([]);
  const [searchQuery, setSearchQuery] = useState("");
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      const permissions = await getBranchPermissions(userId || 0);
      setUserPermissionObject(permissions);
      setLoading(false);
    };
    fillData().then(() => {});
  }, []);
  //#endregion
  //#region function
  const getBranchPermissions = async (
    id: number
  ): Promise<UserBranchPermissionModel[]> => {
    return await getUserBranchPermission(id, isArabic);
  };

  const handleSave = async () => {
    if (!userPermissionObject) return;
    setLoading(true);
    await saveUserBranchPermissions(userPermissionObject);
    onActionEvent({
      action: ActionTypeEnum.CloseModelPopup,
    });
    setLoading(false);
  };

  const handleEnableChange = (isEnabled: boolean, rowID: number) => {
    setUserPermissionObject((prev) => {
      const index = prev.findIndex((x) => x.ID === rowID);
      if (index === -1) return prev;
      prev[index].Enable = isEnabled;
      prev[index].rowState = RowStateEnum.Update;
      return [...prev];
    });
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value.toLowerCase());
  };
  const filteredPermissions = userPermissionObject?.filter(
    (permission) =>
      permission.ArabicName.toLowerCase().includes(searchQuery) ||
      permission.EnglishName.toLowerCase().includes(searchQuery)
  );
  //#endregion
  //#region html
  return (
    <LoadingBox isLoading={loading}>
      <div className="d-flex mb-3">
        <input
          type="text"
          className="form-control"
          placeholder={getLabelName("Search by page name")}
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>
      <GridTable
        paginationType="none"
        columns={generateColumns(handleEnableChange)}
        currentPage={1}
        data={filteredPermissions}
        pageSize={userPermissionObject?.length || 1}
        totalRows={userPermissionObject?.length || 1}
      />
      <div className="col-12 d-flex justify-content-end">
        <ButtonBox
          iconType="content-save"
          size="sm"
          type="submit"
          variant="primary"
          className="btn-gradient-primary mx-3 btn-fw"
          onClick={async () => {
            await handleSave();
          }}
        >
          {getLabelName("save")}
        </ButtonBox>
        <ButtonBox
          iconType="receipt"
          size="sm"
          type="button"
          variant="danger"
          className="btn-fw"
          onClick={async () => {
            onActionEvent({
              action: ActionTypeEnum.CloseModelPopup,
            });
          }}
        >
          {getLabelName("Close")}
        </ButtonBox>
      </div>
    </LoadingBox>
  );
  //#endregion
};

const generateColumns = (
  handleEnableChange: (isEnabled: boolean, rowID: number) => void
): TableColumn<UserBranchPermissionModel>[] => {
  return [
    {
      name: getLabelName("Arabic Name"),
      selector: (_row, index) => _row.ArabicName,
    },
    {
      name: getLabelName("English Name"),
      selector: (_row, index) => _row.EnglishName,
    },
    {
      name: getLabelName("Active"),
      // eslint-disable-next-line react/button-has-type
      cell: (row: UserBranchPermissionModel) => (
          <Checkbox
              value={row.Enable}
              onChange={(e: any) => {
                handleEnableChange(e.target.checked, row.ID);
              }}
              checked={row.Enable}
              type="checkbox"
          />
      ),
    },
  ];
};
